import React from 'react';
import { useDispatch } from 'react-redux';
import { allPostByCategory, allPostByAuthor } from '../../../redux/filter/actions';

const SingleBlog = ({ post }) => {
    const dispatch = useDispatch();
    const { title, category, author, readTime, date, image, authorImage } = post;

    const handleByCategory = (category) => {
        dispatch(allPostByCategory(category));
    }

    const handleByAuthor = (author) => {
        dispatch(allPostByAuthor(author));
    }


    return (
        <div
            className="flex flex-col rounded-lg shadow-lg overflow-hidden"
        >
            <div className="flex-shrink-0">
                <img
                    className="h-48 w-full object-cover"
                    src={`${image}`}
                    alt=""
                />
            </div>

            <div
                className="flex-1 bg-white p-6 flex flex-col justify-between"
            >
                <div className="flex-1">
                    <p className="text-sm font-medium text-indigo-600">
                        <span
                            className="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-indigo-100 text-indigo-800 cursor-pointer"
                            onClick={() => handleByCategory(category)}
                        >
                            {category}
                        </span>
                    </p>
                    <p
                        className="text-xl font-semibold text-gray-900"
                    >
                        {title}
                    </p>

                </div>
                <div className="mt-6 flex items-center">
                    <div className="flex-shrink-0">
                        <img
                            onClick={() => handleByAuthor(author)}
                            className="h-10 w-10 rounded-full cursor-pointer"
                            src={`${authorImage}`}
                            alt=""
                        />
                    </div>
                    <div className="ml-3">
                        <p
                            className="text-sm font-medium text-gray-900 hover:underline cursor-pointer"
                            onClick={() => handleByAuthor(author)}
                        >
                            {author}
                        </p>
                        <div
                            className="flex space-x-1 text-sm text-gray-500"
                        >
                            <time dateTime='2020-03-03'>{date}</time>
                            <span aria-hidden="true">
                                &middot;
                            </span>
                            <span> {readTime} </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SingleBlog;